@import '~less/global-variables';
@import '~less/layout/typography';
@import '~modules/search/client/less/variables';
@import '~less/bootstrap/legacy-mixins';

/**
 * Leaflet overrides
 * Original:
 * @link https://github.com/Leaflet/Leaflet/blob/master/dist/leaflet.css
 */

/* zoom and fade animations */
/*
.leaflet-fade-anim .leaflet-tile,
.leaflet-fade-anim .leaflet-popup {
  opacity: 0;
  transition: opacity .2s;
  }
.leaflet-fade-anim .leaflet-tile-loaded,
.leaflet-fade-anim .leaflet-map-pane .leaflet-popup {
  opacity: 1;
  }

*/
.leaflet-zoom-anim .leaflet-zoom-animated {
  .transition-transform(@map-zoom-transition);
}

.leaflet-top,
.leaflet-bottom {
  // Keep dropdowns above Leaflet controls
  // (e.g. search suggestions list goes under zoom buttons at host offer editor)
  z-index: @zindex-dropdown - 1;
}

/* general toolbar styles */
.leaflet-touch .leaflet-bar,
.leaflet-bar {
  user-select: none;
  border-radius: @border-radius-small;
  border: 0;
  background: @map-toolbar-background;
  transition: background 0.2s;

  &:hover {
    background: @map-toolbar-background-hover;
  }

  a {
    &,
    &:hover {
      background: transparent;
      border-bottom: 1px solid @gray-lighter;
      display: block;
      text-align: center;
      text-decoration: none;
      color: black;
      .square(46px);
      line-height: 46px;
      @media (min-width: @screen-md-min) {
        .square(36px);
        line-height: 36px;
      }
    }

    &:first-child {
      .border-top-radius(@border-radius-small);
    }

    &:last-child {
      .border-bottom-radius(@border-radius-small);
      border-bottom: none;
    }

    &.leaflet-active {
      background: rgba(0, 0, 0, 0.05);
    }

    &.leaflet-disabled {
      cursor: default;
      background-color: #f4f4f4;
      color: #bbb;
    }
  }
}
.leaflet-bar a,
.leaflet-control-layers-toggle {
  background-position: 50% 50%;
  background-repeat: no-repeat;
  display: block;
}

/* layers control */

// Layer image is satellite when map style is other
.leaflet-control-layers-toggle,
.leaflet-touch .leaflet-control-layers-toggle {
  .img-retina('~img/map/satellite.png', '~img/map/satellite@2x.png', 46px, 46px);
}

// Layer image is street when map style is satellite
.leaflet-layerstyle-satellite {
  .leaflet-control-layers-toggle,
  .leaflet-touch .leaflet-control-layers-toggle {
    .img-retina('~img/map/street.png', '~img/map/street@2x.png', 46px, 46px);
  }
}

.leaflet-touch .leaflet-control-layers,
.leaflet-control-layers {
  border: 1px solid #fff;
  background: #fff;
  border-radius: @border-radius-small;
}

.leaflet-control-layers-toggle {
  .square(36px);
}

.leaflet-touch .leaflet-control-layers-toggle {
  .square(46px);
}

.leaflet-control-layers .leaflet-control-layers-list,
.leaflet-control-layers-expanded .leaflet-control-layers-toggle {
  display: none;
}

.leaflet-control-layers-expanded .leaflet-control-layers-list {
  display: block;
  position: relative;
}

.leaflet-control-layers-expanded {
  padding: 6px 10px 6px 6px;
  color: @text-color;
  background: #fff;
  // Re-position layer selector for mobile screens,
  // so that it wouldnt cover filter/search inputs
  @media (max-width: @screen-sm-max) {
    position: fixed;
    box-sizing: content-box;
    left: 10px;
    right: 10px;
    bottom: 50%;
    width: auto;
    border: 10px solid rgba(0, 0, 0, 0.35);
    box-shadow: none;
    form:before {
      display: block;
      box-sizing: content-box;
      content: '×';
      position: absolute;
      bottom: -70px;
      left: 50%;
      margin-left: -50px;
      width: 100px;
      height: 40px;
      line-height: 35px;
      font-size: 25px;
      text-align: center;
      box-shadow: 0 1px 5px rgba(0, 0, 0, 0.35);
      color: @btn-primary-color;
      background: @btn-primary-bg;
      pointer-events: none;
    }
  }
  @media (max-width: @screen-sm-max) and (orientation: landscape) {
    bottom: 110px;
  }
}

/* attribution and scale controls */

.leaflet-control-scale-line {
  color: @text-color;
}

.leaflet-container .leaflet-control-scale {
  font-size: @font-size-small;
  font-family: @font-family-brand-regular;
}

// Scale control next to zoom floats next to zoom buttons,
// not under it like by default
.leaflet-control-scale {
  clear: left;
  margin: 40px 20px 0 0;
  speak: none;

  // Zoom buttons are slightly bigger so we need slightly bigger gap
  @media (max-width: @screen-sm-max) {
    margin-top: 60px;
  }

  // Hide improve map links on small screens
  @media (max-width: @screen-xs-max) {
    position: fixed;
    bottom: 5px;
    right: 5px;
    margin: 0;
  }
}

.leaflet-touch {
  .leaflet-control-attribution {
    box-shadow: none;
  }
  .leaflet-control-layers,
  .leaflet-bar {
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.35);
  }
}

/* Attribution  */

@leaflet-attribution-size: 26px;
.leaflet-container .leaflet-control-attribution {
  background: #fff;
  border-radius: (@leaflet-attribution-size / 2);
  padding: 0 31px 0 10px;
  height: @leaflet-attribution-size;
  line-height: @leaflet-attribution-size;
  margin: 10px;
  visibility: hidden;
  color: @text-color;
  font-size: @font-size-small;
  a {
    color: @text-color;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  .improve-map {
    font-weight: bold;

    // Hide improve map links on small screens
    @media (max-width: @screen-sm-max) {
      display: none;
    }
  }
  &:hover {
    visibility: visible;
  }
  // Icon
  &:after {
    // See icons.less for the rest
    color: @text-color;
    background-color: #fff;
    background-color: rgba(255, 255, 255, 0.5);
    border-radius: 50%;
    position: absolute;
    display: inline-block;
    font-size: 18px;
    .square(@leaflet-attribution-size);
    line-height: @leaflet-attribution-size;
    vertical-align: middle;
    bottom: 0;
    right: 0;
    z-index: 1;
    visibility: visible;
    cursor: pointer;
    opacity: 0.75;
  }
}

/* More mobile friendly layer-control */
.leaflet-control-layers {
  label {
    .font-brand-regular();
    font-size: 15px;
    line-height: 15px;
    padding: 8px;
  }
  .leaflet-control-layers-selector {
    margin: 0 8px 0px 0;
    padding: 0;
  }
}

// Smaller margins for controls from map edge on small screens
@media (max-width: @screen-sm-max) {
  .leaflet-left .leaflet-control {
    margin-left: 5px;
  }

  .leaflet-right .leaflet-control {
    margin-right: 5px;
  }

  .leaflet-bottom .leaflet-control {
    margin-bottom: 5px;
  }

  .leaflet-top .leaflet-control {
    margin-top: 5px;
  }
}
